import { createContext, ReactNode, useState } from "react";

const QuotesContext = createContext({});


export const QuotesPopupProvider = ({ children }: { children: ReactNode }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [quoteFormType, setQuoteFormType] = useState<number>(1);

    const value = { open, setOpen, quoteFormType, setQuoteFormType };

    return (
        <QuotesContext.Provider value={value}>
            {children}
        </QuotesContext.Provider>
    )
}

export default QuotesContext;